import getByPath from 'getbypath';
export const errorHandlerUtils = {
	methods: {
		hasError(path, error) {
			if (error) {
				return getByPath(this, `$v.${path}.$dirty`) && getByPath(this, `$v.${path}`) && getByPath(this, `$v.${path}.${error}`) === false;
			} else {
				return getByPath(this, `$v.${path}.$dirty`) && getByPath(this, `$v.${path}.$invalid`);
			}
		},
		validateField(path) {
			setTimeout(() => {
				const touchFn = getByPath(this, `$v.${path}.$touch`);
				touchFn();
			}, 500);
		}
	}
};
